import {Link} from "react-router-dom";
import { Blog, Contact, Donation, Home, Page, Portfolio } from "./Menus";
import {L, langArr} from "../../helpers/lang/lang";
import {useSelector} from "react-redux";
import {getLang} from "../../redux/selectors/lang";
import {selectAboutMenu} from "../../redux/selectors/aboutMenu";
import mobile_bars from "../../public/assets/images/icons/icon-bar.png";
import Select from "react-select";
import DonationPopUp from "../../components/donation_pop_up";
import Logo from "../../public/assets/images/powerofdiaspora.png";
import {useState} from "react";
import CardOrder from "../../components/CardOrder/CardOrder";

const StickNav = ({
  openSidebar,
  openSearchBar,
  logo,
  sidebarImg,
  btnClass,
}) => {
  const aboutMenuList = useSelector(selectAboutMenu);

  const [order, setOrder] = useState(false);
  const [donate, setDonate] = useState(false);

  const curLang = useSelector(getLang());
  return (
      <>
        {donate ? <DonationPopUp onClose={()=>setDonate(false)}/> : null}
      <div className="sticky-header animated slideInDown">
      <div className="header-upper">
        <div className="header-container-box">
          <div className="inner-container">
            <div className="left-column">
              <div className="logo">
                <Link to="/">
                  <a>
                    <img
                      src={Logo}
                      alt=""
                    />
                  </a>
                </Link>
              </div>
              {/*Nav Box*/}
              <div className="nav-outer">
                {/*Mobile Navigation Toggler*/}
                <div className="mobile-nav-toggler">
                  <img src={mobile_bars} alt="" />
                </div>
                {/* Main Menu */}
                <nav className="main-menu navbar-expand-md navbar-light">
                  <div
                    className="collapse navbar-collapse show clearfix"
                    id="navbarSupportedContent"
                  >
                    <ul className="navigation">
                      <li className="dropdown current">
                        <Link to="/">{L("home")}</Link>
                      </li>
                      <li className="dropdown">
                        <Link to="#">{L("about_us")}</Link>
                        <ul>
                          <Page list={aboutMenuList} />
                        </ul>
                        <div className="dropdown-btn">
                          <span className="fa fa-angle-right" />
                        </div>
                      </li>
                      <li className="dropdown">
                        <Link to="/donation-grid">{L("donation_grid")}</Link>
                        <div className="dropdown-btn">
                          <span className="fa fa-angle-right" />
                        </div>
                      </li>
                      <li className="dropdown">
                        <Link to="/blog">{L("blog")}</Link>
                      </li>
                      <Contact />
                    </ul>
                  </div>
                </nav>
                {/* language */}
                <div className="language">
                  <Select
                      value={{label: langArr.find(x => x.id === curLang)?.title}}
                      options={langArr.map(lg=>{
                        return{
                          label: lg.title,
                          value: lg.id
                        }
                      })}
                      onChange={(e)=>{
                        localStorage.setItem("cur-lang", e.value);
                        window.location.reload();
                      }}
                      className={"custom-select"}
                  />
                </div>
              </div>
            </div>
            <div className="right-column">
              <div className="search-toggler" onClick={() => openSearchBar()}>
                <i className="far fa-search" />
              </div>
              <div
                className="menu-bar sidemenu-nav-toggler"
                onClick={() => openSidebar()}
              >
                <img
                  src={
                    sidebarImg
                      ? sidebarImg
                      : "assets/images/icons/icon-menu.png"
                  }
                  alt=""
                />
              </div>
              <a
                className={btnClass ? btnClass : "primary_btn style-seven"}
                onClick={()=>setDonate(true)}
              >
                {L("make_donation")}
                <i className="far fa-heart" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
        {order? <CardOrder onClose={()=>setOrder(false)} onSend={()=>setDonate(true)}/>: null}
    </>
  );
};
export default StickNav;
